<template>
  <div class="product-card-box">
    <div class="product-img">
      <img
        :class="{ imgError }"
        :src="imgUrlPrefix + product.img"
        :alt="product.name"
        @error="handleImgError"
      />
      <div class="img-fallback" v-if="imgError">
        <span class="img-fallback-text">{{ product.name }}</span>
      </div>
    </div>
    <div class="product-info">
      <div class="product-top-row">
        <span class="product-name">{{ product.name }}</span>
        <!-- <span class="product-tag" :class="product.tag === '预售' ? 'pre-order' : 'in-stock'">
          {{ product.tag }}
        </span> -->
      </div>
      <div class="product-price" :class="!product.price ? 'no-price' : ''">{{ product.price || '¥ —' }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StoreProductCard',
  props: {
    imgUrlPrefix: {
      type: String,
      required: true
    },
    product: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      imgError: false
    }
  },
  methods: {
    handleImgError() {
      this.imgError = true;
    }
  }
}
</script>

<style lang="less" scoped>
.product-card-box {
  .product-img {
    height: 280px;
    overflow: hidden;
    background: #f0f0ee;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      padding: 24px;
      display: block;
      transition: transform 0.3s ease;
      &:hover { 
        transform: scale(1.03);
      }
    }
    .img-fallback {
      position: absolute;
      inset: 0;
      background: #f0f0ee;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      gap: 8px;
      display: flex;
      .img-fallback-text {
        font-size: 9px;
        letter-spacing: 2px;
        text-transform: uppercase;
        color: rgba(0,0,0,0.2);
        text-align: center;
        padding: 0 24px;
      }
    }
  }
  .product-info {
    padding: 20px 22px 24px;
    border-top: 1px solid @bdr;
    .product-top-row {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      margin-bottom: 8px;
      gap: 8px;
      .product-name {
        font-size: 14px;
        font-weight: 300;
        color: @ink;
        line-height: 1.4;
      }
      .product-tag {
        font-size: 8px;
        letter-spacing: 1.5px;
        text-transform: uppercase;
        padding: 3px 8px;
        white-space: nowrap;
        flex-shrink: 0;
        &.in-stock {
          border: 1px solid @bdr;
          color: @mute;
        }
        &.pre-order { 
          border: 1px solid @ink;
          color: @ink;
        }
      }
    }
    .product-price {
      font-family: 'Roboto Mono', monospace;
      font-size: 16px;
      font-weight: 100;
      color: @ink;
      letter-spacing: -0.5px;
      margin-top: 4px;
      &.no-price {
        font-size:14px; color:#a6a6a4; letter-spacing:1px;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .product-card-box {
    .product-img {
      height: 220px;

      img {
        object-fit: cover;
        padding: 0;

        &:hover {
          transform: none;
        }
      }
    }

    .product-info {
      padding: 16px 18px;

      .product-top-row {
        margin-bottom: 6px;

        .product-name {
          font-size: 14px;
          line-height: 1.4;
        }
      }

      .product-price {
        font-size: 15px;

        &.no-price {
          font-size: 14px;
        }
      }
    }
  }
}

</style>